// extracted by mini-css-extract-plugin
export default {"benefitsContainer":"benefits_benefitsContainer__EooRa","cardContainer":"benefits_cardContainer__QLaIf","header":"benefits_header__NFIzW","description":"benefits_description__l5-ci"};